export const colors = {
  primary: "#ec2026",
  secondary: "#1B2850",
  cancel: "#637381",
  cancelHover: "#424b52",
  success: "#5cb85c",
};
